import {NOT_FOUND_IMAGE_PATH} from './settings.js'

export const getMakesLabels = ({selectedMakes, makes}) => {
  return makes.filter(make => selectedMakes?.includes(make.id)).map(make => make.label)
}

export const getInitialValue = ({options, value}) => {
  if (options.length === 1) return [options[0].id]
  if (value?.length) return value
  return []
}

export const handleError = ({domain, i18n, error, message = '', redirectTo}) => {
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {InvalidParamsSharedError, NotFoundSharedError} = config.get('COMMON').ERRORS

  console.error(message, error)

  if (error instanceof InvalidParamsSharedError) {
    return {__HTTP__: {redirectTo}}
  }
  if (error instanceof NotFoundSharedError) {
    return {
      isError: true,
      image: `${URL_STATICS_IMAGES}${NOT_FOUND_IMAGE_PATH}`,
      title: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_TITLE'),
      description: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_DESCRIPTION')
    }
  }

  // Generic error case, can be a network error or an unexpected error
  return {
    isError: true,
    image: `${URL_STATICS_IMAGES}${NOT_FOUND_IMAGE_PATH}`,
    title: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_TITLE'),
    description: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_DESCRIPTION')
  }
}
